export default class AtividadeColaborador {

  constructor(
    IdEmpresa = 1,
    IdAtividade = null,
    IdColaborador = null,
    Colaborador = ''
  ) {

    this.IdEmpresa = IdEmpresa;
    this.IdAtividade = IdAtividade;
    this.IdColaborador = IdColaborador;
    this.Colaborador = Colaborador;
  }
  
}